import { Sender, InvokeCallback, Receiver, EventObject, Event } from 'xstate';

export default function asyncCallback(func: InvokeCallback): InvokeCallback {
  return (callback: Sender<any>, onReceive: Receiver<EventObject>) => {
    let stopped = false;
    const promise = Promise.resolve(
      func(
        (event: Event<any>): void => {
          if (!stopped) {
            callback(event);
          }
        },
        (listener: (event: EventObject) => void): void => {
          if (!stopped) {
            onReceive(listener);
          }
        }
      )
    );
    return () => {
      stopped = true;
      promise.then(clean => clean && clean());
    };
  };
}
